import { Pais } from './../models/pais.model.';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaisService {
  constructor(private httpClient: HttpClient) {}

  public getAll(): Observable<any[]> {
    let params = new HttpParams();

    return this.httpClient.get<any[]>(
      environment.api_base + environment.tenant + '/paises',
      { params }
    );
  }
}
